import { render, staticRenderFns } from "./TenantActionModal.vue?vue&type=template&id=49c25baa&"
import script from "./TenantActionModal.vue?vue&type=script&lang=js&"
export * from "./TenantActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports